import { render } from "./ListeValidationQueuePage.vue?vue&type=template&id=66380596&ts=true"
import script from "./ListeValidationQueuePage.vue?vue&type=script&lang=ts"
export * from "./ListeValidationQueuePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__